import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getOrderInvoice = createAsyncThunk('coOrders/getOrderInvoice',
  async (orderId, { rejectWithValue }) => {
    try {
      const { data } = await authGet(`/co/orders/invoice/${orderId}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getOrderInvoice;
